import serviceUrls from 'src/constants/serviceUrls';
import axiosRequest from 'src/helpers/axiosRequest';

export function createShowOrganizer(body = {}) {
  return axiosRequest('post', serviceUrls.CMS_CREATE_SSIORGRANIZER, body);
}

export function persistShowOrganizer(body = {}) {
  return axiosRequest('post', serviceUrls.CMS_PERSIST_ORGANIZER, body);
}

export function submitShowOrganizer(body = {}) {
  return axiosRequest('post', serviceUrls.CMS_SUBMIT_ORGANIZER, body);
}

export function fetchShowOrganizer(params) {
  return axiosRequest('get', serviceUrls.CMS_GET_SHOWORGANIZER, params);
}

export function fetchServiceBatchInitiations(params, config) {
  return axiosRequest('post', serviceUrls.SSI_GET_BATCH_LIST, params, config);
}

export function addCMSFile(data, config) {
  return axiosRequest('post', serviceUrls.CMS_FILE_UPLOAD, data, config || {});
}

export function removeCMSFile(data) {
  return axiosRequest('post', serviceUrls.CMS_FILE_REMOVE, data);
}

export function downloadCMSFile(data) {
  return axiosRequest('get', serviceUrls.CMS_FILE_DOWNLOAD, data);
}

export function unlockQuestionnaire(personId, assigneeServicePlanGlobalId) {
  return axiosRequest('post', serviceUrls.CMS_SAVE_GOACCESS_DETAILS, { personId, assigneeServicePlanGlobalId, forceAccessCleanup: true });
}

export function getWorkPaperUrl(data = {}) {
  return axiosRequest('post', serviceUrls.GET_WORKPAPER_URL, data);
}

export function fetchPreproformaXML({ assigneeServicePlanGlobalId, organizerTypeId, yearTypeId, year }) {
  return axiosRequest(
    'get',
    serviceUrls.DOWNLOAD_PREPROFORMA_XML,
    {
      assigneeServicePlanGlobalId,
      organizerTypeId,
      yearTypeId,
      year: year || 2017, // hardcoded for now
    },
    { timeout: 180000 },
  );
}

export function fetchAnswerkeyXML({ assigneeServicePlanGlobalId, organizerTypeId, yearTypeId, year }) {
  return axiosRequest(
    'get',
    serviceUrls.DOWNLOAD_ANSWERKEY_XML,
    {
      assigneeServicePlanGlobalId,
      organizerTypeId,
      yearTypeId,
      year: year || 2017, // hardcoded for now
    },
    { timeout: 180000 },
  );
}

export function fetchRelatedList(params, config) {
  return axiosRequest('post', serviceUrls.CMS_RELATED_LIST, params, config);
}

export function fetchRelatedDetail(request) {
  return axiosRequest('get', serviceUrls.CMS_RELATED_DETAILS, request, { timeout: 180000 });
}

export function upsertRelatedRecord(request) {
  return axiosRequest('post', serviceUrls.CMS_RELATED_UPSERT, request, { timeout: 180000 });
}

export function deleteRelatedRecord(request) {
  return axiosRequest('post', serviceUrls.CMS_RELATED_DELETE, request, { timeout: 180000 });
}
